import React from 'react';

interface InactivityWarningModalProps {
  showWarning: boolean;
  minutesRemaining: number;
  resetTimer: () => void;
  onLogout: () => void;
}

const InactivityWarningModal: React.FC<InactivityWarningModalProps> = ({
  showWarning,
  minutesRemaining,
  resetTimer,
  onLogout,
}) => {
  if (!showWarning) return null;

  return (
    <div style={{
      position: 'fixed',
      inset: 0,
      zIndex: 9999,
      background: 'rgba(0,0,0,0.55)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px',
    }}>
      <div style={{
        background: '#fff',
        borderRadius: 14,
        width: '100%',
        maxWidth: 460,
        boxShadow: '0 24px 64px rgba(0,0,0,0.22)',
        overflow: 'hidden',
      }}>
        <div style={{
          background: '#fffbeb',
          borderBottom: '1px solid #fde68a',
          padding: '18px 28px',
          display: 'flex',
          alignItems: 'center',
          gap: 12,
        }}>
          <h2 style={{ margin: 0, fontSize: 16, fontWeight: 700, color: '#92400e' }}>
            Session Inactivity Warning
          </h2>
        </div>
        <div style={{ padding: '24px 28px' }}>
          <p style={{ margin: '0 0 24px', fontSize: 14, color: '#374151', lineHeight: 1.65 }}>
            Your session will expire in <strong>{minutesRemaining}</strong> minute{minutesRemaining !== 1 ? 's' : ''} due to inactivity. Click Continue to stay logged in.
          </p>
          <div style={{ display: 'flex', gap: 12 }}>
            <button
              onClick={resetTimer}
              style={{
                flex: 1,
                padding: '11px 0',
                border: '2px solid #002060',
                borderRadius: 8,
                background: '#002060',
                color: '#fff',
                fontWeight: 700,
                fontSize: 13.5,
                cursor: 'pointer',
              }}
            >
              Continue Session
            </button>
            <button
              onClick={onLogout}
              style={{
                flex: 1,
                padding: '11px 0',
                border: '2px solid #dc2626',
                borderRadius: 8,
                background: '#dc2626',
                color: '#fff',
                fontWeight: 700,
                fontSize: 13.5,
                cursor: 'pointer',
              }}
            >
              Logout Now
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InactivityWarningModal;
